import { Form, Button } from 'semantic-ui-react';
import React from 'react';
import { func, node, bool, string } from 'prop-types';

const PrimaryButton = ({ onClick, children, qa, fluid = false }) => (
  <Form.Field
    type="button"
    control={Button}
    size="small"
    primary
    className="field--center"
    onClick={onClick}
    data-qa={qa}
    fluid={fluid}
    data-testid="primary-button"
  >
    {children}
  </Form.Field>
);

PrimaryButton.propTypes = {
  onClick: func,
  children: node.isRequired,
  fluid: bool,
  qa: string
};

export default PrimaryButton;
